import {
  RefObject,
  Dispatch,
  SetStateAction,
  createContext,
  MouseEvent,
} from "react";

export type DialogContextProps = {
  close: (e?: MouseEvent<HTMLElement>) => void;
  ref?: RefObject<HTMLDialogElement>;
  hasOpenPopover?: boolean;
  setHasOpenPopover?: Dispatch<SetStateAction<boolean | undefined>>;
};

export const DialogContext = createContext<DialogContextProps | null>(null);
